import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import type { StandardPolicy } from '@system-config/policy-management/domain';
import { GET_STANDARD_POLICIES } from '@system-config/policy-management/graphql';
import { useMemo } from 'react';

interface StandardPoliciesResponse {
  standardPolicies: {
    policies: StandardPolicy[];
  };
}

interface UseStandardPoliciesOptions {
  enabled?: boolean;
}

export function useStandardPolicies(options?: UseStandardPoliciesOptions) {
  const { data, loading, error, refetch } = useQuery<StandardPoliciesResponse>(GET_STANDARD_POLICIES, {
    variables: options ? { input: { enabled: options.enabled } } : undefined,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  const policies: StandardPolicy[] = useMemo(() => data?.standardPolicies?.policies || [], [data]);

  const errors = useMemo(() => {
    if (!error) return undefined;

    return transformErrors(error);
  }, [error]);

  return {
    policies,
    loading,
    errors,
    refetch,
  };
}
